import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.INSERT_ALARM_CONDITION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.INSERT_ALARM_CONDITION_SUCCESS:
      return {
        ...state,
        pending: false,
      };
    case types.INSERT_ALARM_CONDITION_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    default:
      return state;
  }
}
